// extracted by mini-css-extract-plugin
export default {"BouncingLoader":"LoadingDots_BouncingLoader__z44Hc","bouncing-loader":"LoadingDots_bouncing-loader__cSo4i"};